var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{ref:"editor",attrs:{"id":_vm.id,"editor-options":_vm.editorSettings,"editor-toolbar":_vm.customToolbar},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }